// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pricing-templates__selectors-wrapper[data-v-611608c6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin: 0 -10px;\n}\n.pricing-templates__selector[data-v-611608c6] {\n  width: 100%;\n  margin-top: 15px;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
